import(/* webpackMode: "eager", webpackExports: ["WishlistView"] */ "/app/apps/topshop/views/wishlistView/index.tsx");
